module.exports = __webpack_public_path__ + "img/logo-small.9eebf1119f8675315e6a8a9a76fc38e1.svg";